<template>
  <el-drawer title="设置" :visible.sync="dialogVisible" size="70%" @close="handleClose">
    <el-tabs tab-position="left" v-if="editResourceType === 1 || isEditMode">
      <el-tab-pane label="权限设置">
        <el-form :model="form" :rules="rules" ref="form">
          <!-- <el-form-item v-if="!isEditMode" label="文件夹名称" prop="folderName">
            <el-input v-model="form.folderName" placeholder="请输入文件夹名称" maxlength="20" show-word-limit></el-input>
          </el-form-item>-->
          <el-form-item v-if="isEditMode" label="是否公有文件" prop="publicFlag">
            <el-radio-group v-model="form.publicFlag">
              <el-radio :label="1">公有</el-radio>
              <el-radio :label="0">私有</el-radio>
            </el-radio-group>
          </el-form-item>
          <template v-if="form.publicFlag === 0">
            <el-form-item :prop="isEditMode ? '' : 'permissions'">
              <div class="permission-selector" v-loading="permissionLoading">
                <!-- 左侧：权限类型选择区 -->
                <div class="left-panel">
                  <div class="tab-header">
                    <div class="tab-item" :class="{ active: subjectType === 1 }" @click="handleSubjectTypeChange(1)">
                      部门
                    </div>
                    <div class="tab-item" :class="{ active: subjectType === 2 }" @click="handleSubjectTypeChange(2)">
                      角色
                    </div>
                    <div class="tab-item" :class="{ active: subjectType === 0 }" @click="handleSubjectTypeChange(0)">
                      人员
                    </div>
                  </div>
                  <!-- 搜索框 -->
                  <div class="search-box">
                    <el-input v-model="searchKeyword" placeholder="请搜索" prefix-icon="el-icon-search" size="small"
                      clearable></el-input>
                  </div>
                  <!-- 选择列表区域 -->
                  <div class="select-list">
                    <!-- 用户列表 -->
                    <div v-if="subjectType === 0" class="list-content">
                      <div class="folder-permission-member-picker">
                        <select-member-modal placeholder="请选择人员（支持按部门筛选）" v-model="memberPickerValue"
                          :trigger-change="true" value-field="id" :multiple="true" :popover-z-index="4000"
                          @send-change="handleMemberPickerSendChange" @change="handleMemberPickerChange" />
                      </div>
                    </div>
                    <!-- 角色列表 -->
                    <div v-if="subjectType === 2" class="list-content">
                      <div v-for="role in filteredRoleList" :key="'role-' + role.id" class="list-item"
                        @click="toggleSelection('role', role)">
                        <el-checkbox :value="isSelected('role', role.id)" @click.native.stop
                          @change="toggleSelection('role', role)">
                          <div class="item-content">
                            <el-avatar :size="32" class="item-avatar" style="background-color: #67C23A;">
                              角
                            </el-avatar>
                            <span class="item-name">{{ role.roleName }}</span>
                          </div>
                        </el-checkbox>
                      </div>
                      <el-empty v-if="filteredRoleList.length === 0" description="无匹配结果" :image-size="60"></el-empty>
                    </div>
                    <!-- 部门树 -->
                    <div v-if="subjectType === 1" class="list-content">
                      <el-tree :data="permissionData.deptTreeList" show-checkbox node-key="deptId" ref="deptTree"
                        :props="deptTreeProps" :filter-node-method="filterDeptNode" @check="handleDeptCheck">
                      </el-tree>
                      <el-empty v-if="!permissionData.deptTreeList || permissionData.deptTreeList.length === 0"
                        description="暂无数据" :image-size="60"></el-empty>
                    </div>

                  </div>
                </div>

                <!-- 右侧：已选择对象展示区 -->
                <div class="right-panel">
                  <div class="selected-header">
                    <span>已选({{ selectedItems.length }})</span>
                    <el-button type="text" size="small" @click="clearAll">清空</el-button>
                  </div>
                  <div class="selected-list">
                    <div v-for="item in selectedItems" :key="item.type + '-' + item.id" class="selected-item">
                      <div class="selected-item-left">
                        <el-avatar :size="32" :src="item.type === 'user' ? item.avatar : ''"
                          :style="getAvatarStyle(item.type)" class="selected-avatar">
                          {{ getAvatarText(item) }}
                        </el-avatar>
                        <div class="selected-info">
                          <div class="selected-name">{{ item.name }}</div>
                           <div class="selected-type">{{ getTypeLabel(item.type) }}</div>
                        </div>
                      </div>
                      <div class="selected-item-left">
                        <div>
                          <el-checkbox v-model="item.canEdit">编辑</el-checkbox>
                          <el-checkbox v-model="item.canDownload">下载</el-checkbox>
                        </div>
                        <el-button type="text" icon="el-icon-close" size="large" class="remove-btn"
                          @click="removeSelection(item)"></el-button>
                      </div>


                    </div>
                    <el-empty v-if="selectedItems.length === 0" description="请从左侧选择权限对象" :image-size="80"></el-empty>
                  </div>
                </div>

              </div>
            </el-form-item>
          </template>
        </el-form>

        <div class="dialog-footer">
          <el-button @click="handleClose">取 消</el-button>
          <el-button type="primary" @click="handleConfirm" :loading="confirmLoading">确 定</el-button>
        </div>
      </el-tab-pane>
      <el-tab-pane label="标签设置" v-if="editResourceType === 1">
        <div class="tag-container">
          <div v-for="tagGroup in tagData" :key="tagGroup.dictId" class="tag-group">
            <div class="tag-group-title">{{ tagGroup.dictName }}</div>
            <div class="tag-options">
              <el-checkbox-group v-model="selectedTags[tagGroup.dictCode]">
                <el-checkbox v-for="option in tagGroup.options" :key="option.dictItemId" :label="option.dictItemId"
                  class="tag-checkbox">
                  {{ option.label }}
                </el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
          <el-empty v-if="!tagData || tagData.length === 0" description="暂无标签数据" :image-size="80"></el-empty>
        </div>
        <div class="dialog-footer">
          <el-button @click="handleClose">取 消</el-button>
          <el-button type="primary" @click="handleSaveTags" :loading="saveTagLoading">保 存</el-button>
        </div>
      </el-tab-pane>
      <!-- <el-tab-pane label="角色管理">角色管理</el-tab-pane>
      <el-tab-pane label="定时任务补偿">定时任务补偿</el-tab-pane> -->
    </el-tabs>
    <template v-else>
      <el-form :model="form" :rules="rules" ref="form" label-width="120px">
        <el-form-item v-if="!isEditMode" label="文件夹名称" prop="folderName">
          <el-input v-model="form.folderName" placeholder="请输入文件夹名称" maxlength="20" show-word-limit></el-input>
        </el-form-item>
        <div class="dialog-footer">
          <el-button @click="handleClose">取 消</el-button>
          <el-button type="primary" @click="handleConfirm" :loading="confirmLoading">确 定</el-button>
        </div>
        <!-- <el-form-item v-if="!isEditMode" label="是否公有文件" prop="publicFlag">
          <el-radio-group v-model="form.publicFlag">
            <el-radio :label="1">公有</el-radio>
            <el-radio :label="0">私有</el-radio>
          </el-radio-group>
        </el-form-item>

        <template v-if="isEditMode || form.publicFlag === 0">
          <el-form-item label="权限对象选择" :prop="isEditMode ? '' : 'permissions'">
            <div class="permission-selector" v-loading="permissionLoading">
              <div class="left-panel">
                <div class="tab-header">
                  <div class="tab-item" :class="{ active: subjectType === 1 }" @click="handleSubjectTypeChange(1)">
                    部门
                  </div>
                  <div class="tab-item" :class="{ active: subjectType === 2 }" @click="handleSubjectTypeChange(2)">
                    角色
                  </div>
                  <div class="tab-item" :class="{ active: subjectType === 0 }" @click="handleSubjectTypeChange(0)">
                    人员
                  </div>
                </div>
                <div class="search-box">
                  <el-input v-model="searchKeyword" placeholder="请搜索" prefix-icon="el-icon-search" size="small"
                    clearable></el-input>
                </div>
                <div class="select-list">
                  <div v-if="subjectType === 0" class="list-content">
                    <div v-for="user in filteredUserList" :key="'user-' + user.id" class="list-item"
                      @click="toggleSelection('user', user)">
                      <el-checkbox :value="isSelected('user', user.id)" @click.native.stop
                        @change="toggleSelection('user', user)">
                        <div class="item-content">
                          <el-avatar :size="32" :src="user.avatar" class="item-avatar">
                            {{ user.fullName ? user.fullName.charAt(0) : '用' }}
                          </el-avatar>
                          <span class="item-name">{{ user.fullName }}</span>
                        </div>
                      </el-checkbox>
                    </div>
                    <el-empty v-if="filteredUserList.length === 0" description="无匹配结果" :image-size="60"></el-empty>
                  </div>

                  <div v-if="subjectType === 2" class="list-content">
                    <div v-for="role in filteredRoleList" :key="'role-' + role.id" class="list-item"
                      @click="toggleSelection('role', role)">
                      <el-checkbox :value="isSelected('role', role.id)" @click.native.stop
                        @change="toggleSelection('role', role)">
                        <div class="item-content">
                          <el-avatar :size="32" class="item-avatar" style="background-color: #67C23A;">
                            角
                          </el-avatar>
                          <span class="item-name">{{ role.roleName }}</span>
                        </div>
                      </el-checkbox>
                    </div>
                    <el-empty v-if="filteredRoleList.length === 0" description="无匹配结果" :image-size="60"></el-empty>
                  </div>

                  <div v-if="subjectType === 1" class="list-content">
                    <el-tree :data="permissionData.deptTreeList" show-checkbox node-key="deptId" ref="deptTree"
                      :props="deptTreeProps" :filter-node-method="filterDeptNode" @check="handleDeptCheck">
                    </el-tree>
                    <el-empty v-if="!permissionData.deptTreeList || permissionData.deptTreeList.length === 0"
                      description="暂无数据" :image-size="60"></el-empty>
                  </div>

                  <div v-if="subjectType === 3" class="list-content">
                    <el-empty description="岗位功能开发中" :image-size="60"></el-empty>
                  </div>

                  <div v-if="subjectType === 4" class="list-content">
                    <el-empty description="群组功能开发中" :image-size="60"></el-empty>
                  </div>
                </div>
              </div>

              <div class="right-panel">
                <div class="selected-header">
                  <span>已选({{ selectedItems.length }})</span>
                  <el-button type="text" size="small" @click="clearAll">清空</el-button>
                </div>
                <div class="selected-list">
                  <div v-for="item in selectedItems" :key="item.type + '-' + item.id" class="selected-item">
                    <el-avatar :size="32" :src="item.type === 'user' ? item.avatar : ''"
                      :style="getAvatarStyle(item.type)" class="selected-avatar">
                      {{ getAvatarText(item) }}
                    </el-avatar>
                    <div class="selected-info">
                      <div class="selected-name">{{ item.name }}</div>
                      <div class="selected-type">{{ getTypeLabel(item.type) }}</div>
                    </div>
                    <el-button type="text" icon="el-icon-close" size="small" class="remove-btn"
                      @click="removeSelection(item)"></el-button>
                  </div>
                  <el-empty v-if="selectedItems.length === 0" description="请从左侧选择权限对象" :image-size="80"></el-empty>
                </div>
              </div>
            </div>
          </el-form-item>
        </template> -->
      </el-form>


    </template>
    <!-- <span class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleConfirm" :loading="confirmLoading">确 定</el-button>
    </span> -->
  </el-drawer>
</template>

<script>
export default {
  name: "FolderPermissionDialog",
  props: {
    parentId: {
      type: String,
      default: "0"
    }
  },
  components: {
    SelectMemberModal: () => import('@/components/SelectMemberModal.vue'),
  },
  data() {
    return {
      title: "新增文件夹",
      dialogVisible: false,
      confirmLoading: false,
      permissionLoading: false,
      subjectType: 1, // 0-用户 1-部门 2-角色 3-岗位 4-群组
      selectedItems: [], // 已选择的权限对象列表（支持混合类型）
      /** 与 SelectMemberModal 绑定（字符串），勿与 selectedItems 对象数组共用 */
      memberPickerValue: '',
      searchKeyword: "", // 搜索关键词
      isEditMode: false, // 是否为编辑模式
      editResourceId: null, // 编辑的资源ID
      editResourceType: null, // 编辑的资源类型 0-文件夹 1-文件
      form: {
        folderName: "",
        publicFlag: 1, // 默认公有
      },
      rules: {
        folderName: [
          { required: true, message: "请输入文件夹名称", trigger: "blur" },
          { max: 20, message: "文件夹名称不能超过20个字符", trigger: "blur" }
        ],
        publicFlag: [
          { required: true, message: "请选择是否公有文件", trigger: "blur" }
        ],
        permissions: [
          {
            validator: (rule, value, callback) => {
              if (this.form.publicFlag === 0 && this.selectedItems.length === 0) {
                callback(new Error("请至少选择一个权限对象"));
              } else {
                callback();
              }
            },
            trigger: "change"
          }
        ]
      },
      permissionData: {
        userList: [],
        roleList: [],
        deptTreeList: []
      },
      deptTreeProps: {
        children: "children",
        label: "deptName"
      },
      tagData: [],
      selectedTags: {},
      originalSelectedTags: [], // 保存原始已选标签的 dictItemId 数组
      tagLoading: false,
      saveTagLoading: false
    };
  },
  computed: {
    // 过滤后的用户列表
    filteredUserList() {
      if (!this.searchKeyword) {
        return this.permissionData.userList || [];
      }
      const keyword = this.searchKeyword.toLowerCase();
      return (this.permissionData.userList || []).filter(user => {
        return (
          (user.fullName && user.fullName.toLowerCase().includes(keyword)) ||
          (user.username && user.username.toLowerCase().includes(keyword)) ||
          (user.phone && user.phone.includes(keyword))
        );
      });
    },
    // 过滤后的角色列表
    filteredRoleList() {
      if (!this.searchKeyword) {
        return this.permissionData.roleList || [];
      }
      const keyword = this.searchKeyword.toLowerCase();
      return (this.permissionData.roleList || []).filter(role => {
        return (
          (role.roleName && role.roleName.toLowerCase().includes(keyword)) ||
          (role.remark && role.remark.toLowerCase().includes(keyword))
        );
      });
    }
  },
  watch: {
    // 监听搜索关键词变化，实时过滤部门树
    searchKeyword(val) {
      if (this.subjectType === 1 && this.$refs.deptTree) {
        this.$refs.deptTree.filter(val);
      }
    },
    memberPickerValue(val) {
      this.syncSelectedUsersFromPickerValue(val);
    }
  },
  methods: {
    safeValidatePermissions() {
      if (!this.$refs.form || this.isEditMode) return;
      this.$refs.form.validateField('permissions');
    },
    uniqueSelectedItems(items = []) {
      const map = new Map();
      items.forEach(item => {
        if (!item || item.id === undefined || item.id === null || item.id === '') return;
        const key = `${item.type}-${String(item.id)}`;
        if (!map.has(key)) {
          map.set(key, item);
        }
      });
      return Array.from(map.values());
    },
    /**
     * 打开对话框 - 新增模式
     */
    openDialog() {
      this.isEditMode = false;
      this.title = "新增文件夹";
      this.subjectType = 1,
        this.dialogVisible = true;
      this.loadPermissionData();
    },

    /**
     * 打开对话框 - 编辑权限模式
     * @param {String} resourceId - 资源ID
     * @param {Number} resourceType - 资源类型 0-文件夹 1-文件
     */
    openEditDialog(resourceId, resourceType) {
      // console.log("🚀 ~ resourceType:", resourceType)
      // console.log("🚀 ~ resourceId:", resourceId)
      this.isEditMode = true;
      this.editResourceId = resourceId;
      this.editResourceType = resourceType;
      this.title = "权限设置";
      this.dialogVisible = true;
      this.getAlltags()

      // 先加载权限组数据，然后加载当前权限
      this.permissionLoading = true;
      this.$HttpService.post("/permission/getPermissionGroup")
        .then(res => {
          this.permissionData = {
            userList: res.userList || [],
            roleList: res.roleList || [],
            deptTreeList: res.deptTreeList || []
          };
          // 权限组数据加载完成后，再加载当前权限
          this.loadCurrentPermissions(resourceId, resourceType);
        })
        .catch(() => {
          this.$message.error("获取权限数据失败");
          this.permissionLoading = false;
        });
    },

    /**
     * 获取所有标签数据
     */
    async getAlltags() {
      this.tagLoading = true;
      try {
        const res = await this.$HttpService.get("/file-tag/getAllTags");
        if (res && res.length > 0) {
          this.tagData = res;

          // 初始化 selectedTags 对象
          this.selectedTags = {};
          this.tagData.forEach(group => {
            this.$set(this.selectedTags, group.dictCode, []);
          });

          // 加载当前文件已选标签
          await this.loadFileTags();
        }
      } catch (error) {
        console.error('获取标签数据失败:', error);
        this.$message.error("获取标签数据失败");
      } finally {
        this.tagLoading = false;
      }
    },

    /**
     * 加载文件已选标签
     */
    async loadFileTags() {
      if (this.editResourceType === 0) return;

      try {
        const res = await this.$HttpService.post("/file-info/detail", {
          id: this.editResourceId
        });

        if (res && res.tags && res.tags.length > 0) {
          // 提取所有 dictItemId
          this.originalSelectedTags = res.tags.map(tag => tag.dictItemId);

          // 回显已选标签到对应的分组
          res.tags.forEach(tag => {
            if (this.selectedTags[tag.dictCode]) {
              if (!this.selectedTags[tag.dictCode].includes(tag.dictItemId)) {
                this.selectedTags[tag.dictCode].push(tag.dictItemId);
              }
            }
          });

        }
      } catch (error) {
        console.error('获取文件标签失败:', error);
      }
    },

    /**
     * 保存标签
     */
    async handleSaveTags() {
      this.saveTagLoading = true;
      try {
        // 收集所有选中的标签 ID
        const allSelectedIds = [];
        Object.values(this.selectedTags).forEach(ids => {
          allSelectedIds.push(...ids);
        });

        // 再添加所有当前选中的标签
        if (allSelectedIds.length > 0) {
          await this.$HttpService.post("/file-tag/setTags", {
            fileId: this.editResourceId,
            dictItemIds: allSelectedIds
          });
        }

        this.$message.success("标签保存成功");
        this.originalSelectedTags = [...allSelectedIds];
        this.$emit("ok", this.editResourceId, false);
        this.handleClose();


      } catch (error) {
        console.error('保存标签失败:', error);
        this.$message.error("保存标签失败");
      } finally {
        this.saveTagLoading = false;
      }
    },
    /**
     * 关闭对话框
     */
    handleClose() {
      this.dialogVisible = false;
      this.resetForm();
    },

    /**
     * 重置表单
     */
    resetForm() {
      this.form = {
        folderName: "",
        publicFlag: 1
      };
      this.subjectType = 0;
      this.selectedItems = [];
      this.memberPickerValue = '';
      this.searchKeyword = "";
      this.confirmLoading = false;
      this.isEditMode = false;
      this.editResourceId = null;
      this.editResourceType = null;
      if (this.$refs.form) {
        this.$refs.form.clearValidate();
      }
      if (this.$refs.deptTree) {
        this.$refs.deptTree.setCheckedKeys([]);
      }
    },

    /**
     * 加载权限数据
     */
    loadPermissionData() {
      this.permissionLoading = true;
      this.$HttpService.post("/permission/getPermissionGroup")
        .then(res => {
          this.permissionData = {
            userList: res.userList || [],
            roleList: res.roleList || [],
            deptTreeList: res.deptTreeList || []
          };
          this.permissionLoading = false;
        })
        .catch(() => {
          this.$message.error("获取权限数据失败");
          this.permissionLoading = false;
        });
    },

    /**
     * 权限类型切换
     */
    handleSubjectTypeChange(type) {
      this.subjectType = type;
      this.searchKeyword = "";

    },

    /**
     * 判断是否已选择
     */
    isSelected(type, id) {
      return this.selectedItems.some(item => item.type === type && item.id === id);
    },

    /**
     * 切换选择状态
     */
    toggleSelection(type, data) {
      const index = this.selectedItems.findIndex(item => item.type === type && item.id === data.id);

      if (index > -1) {
        // 已存在，移除
        this.selectedItems.splice(index, 1);
      } else {
        // 不存在，添加
        let item = {
          type: type,
          id: data.id,
          name: '',
          avatar: '',
          canEdit: false,
          canDownload: false
        };

        if (type === 'user') {
          item.name = data.fullName || data.username;
          item.avatar = data.avatar;
          item.subjectType = 0;
        } else if (type === 'role') {
          item.name = data.roleName;
          item.subjectType = 2;
        }

        this.selectedItems.push(item);
      }

      // 触发表单验证
      this.safeValidatePermissions();
    },

    /**
     * 部门树选择事件
     */
    handleDeptCheck(data, checkedInfo) {
      // 获取所有选中的部门节点
      const checkedNodes = this.$refs.deptTree.getCheckedNodes();

      // 移除所有部门类型的选择
      this.selectedItems = this.selectedItems.filter(item => item.type !== 'dept');

      // 添加新选中的部门
      checkedNodes.forEach(node => {
        this.selectedItems.push({
          type: 'dept',
          id: node.deptId,
          name: node.deptName,
          subjectType: 1,
          canEdit: false,
          canDownload: false
        });
      });

      // 触发表单验证
      this.safeValidatePermissions();
    },

    /**
     * 部门树节点过滤方法
     */
    filterDeptNode(value, data) {
      if (!value) return true;
      return data.deptName.toLowerCase().includes(value.toLowerCase());
    },

    /**
     * 移除选择
     */
    removeSelection(item) {
      const index = this.selectedItems.findIndex(i => i.type === item.type && i.id === item.id);
      if (index > -1) {
        this.selectedItems.splice(index, 1);
      }
      if (item.type === 'user') {
        this.syncMemberPickerValueFromSelected();
      }

      // 如果是部门，同步更新树的选中状态
      if (item.type === 'dept' && this.$refs.deptTree) {
        const checkedKeys = this.selectedItems
          .filter(i => i.type === 'dept')
          .map(i => i.id);
        this.$refs.deptTree.setCheckedKeys(checkedKeys);
      }

      // 触发表单验证
      this.safeValidatePermissions();
    },

    /**
     * 清空所有选择
     */
    clearAll() {
      this.selectedItems = [];
      this.syncMemberPickerValueFromSelected();
      if (this.$refs.deptTree) {
        this.$refs.deptTree.setCheckedKeys([]);
      }
      // 触发表单验证
      this.safeValidatePermissions();
    },

    /**
     * 获取类型标签
     */
    getTypeLabel(type) {
      const typeMap = {
        'user': '(人员)',
        'role': '(角色)',
        'dept': '(部门)',
        'position': '(岗位)',
        'group': '(群组)',
        'public': '(公开)'
      };
      return typeMap[type] || '';
    },

    /**
     * 获取头像样式
     */
    getAvatarStyle(type) {
      const styleMap = {
        'role': { backgroundColor: '#67C23A' },  // 绿色
        'dept': { backgroundColor: '#409EFF' },  // 蓝色
        'user': {},  // 用户使用默认样式或头像图片
        'public': { backgroundColor: '#E6A23C' }  // 橙色
      };
      return styleMap[type] || {};
    },

    /**
     * 获取头像文本
     */
    getAvatarText(item) {
      if (item.type === 'role') {
        return '角';
      } else if (item.type === 'dept') {
        return '部';
      } else if (item.type === 'user') {
        return item.name ? item.name.charAt(0) : '用';
      } else if (item.type === 'public') {
        return '公';
      }
      return '?';
    },
    handleMemberPickerChange(value) {
      this.syncSelectedUsersFromPickerValue(value);
    },
    handleMemberPickerSendChange(users) {
      const userList = Array.isArray(users) ? users : [];
      const previousUserMap = new Map(
        this.selectedItems
          .filter(item => item.type === 'user')
          .map(item => [String(item.id), item])
      );
      const nextUserItems = userList
        .filter(user => user && user.id !== undefined && user.id !== null && user.id !== '')
        .map(user => {
          const id = user.id;
          const previous = previousUserMap.get(String(id)) || {};
          return {
            type: 'user',
            id: id,
            name: user.fullName || user.username || user.account || '',
            avatar: previous.avatar || '',
            subjectType: 0,
            canEdit: typeof previous.canEdit === 'boolean' ? previous.canEdit : false,
            canDownload: typeof previous.canDownload === 'boolean' ? previous.canDownload : false
          };
        });
      const nonUserItems = this.selectedItems.filter(item => item.type !== 'user');
      this.selectedItems = this.uniqueSelectedItems([...nonUserItems, ...nextUserItems]);
      this.safeValidatePermissions();
    },
    syncSelectedUsersFromPickerValue(value) {
      const idList = [...new Set(String(value || '')
        .split(',')
        .map(id => id && id.trim())
        .filter(Boolean))];
      if (!idList.length) {
        const nonUserItems = this.selectedItems.filter(item => item.type !== 'user');
        if (nonUserItems.length !== this.selectedItems.length) {
          this.selectedItems = nonUserItems;
        }
        return;
      }
      const userMap = new Map((this.permissionData.userList || []).map(user => [String(user.id), user]));
      const previousUserMap = new Map(
        this.selectedItems
          .filter(item => item.type === 'user')
          .map(item => [String(item.id), item])
      );
      const nextUserItems = idList.map(id => {
        const currentUser = userMap.get(String(id)) || {};
        const previous = previousUserMap.get(String(id)) || {};
        return {
          type: 'user',
          id: currentUser.id != null ? currentUser.id : id,
          name: currentUser.fullName || currentUser.username || previous.name || id,
          avatar: currentUser.avatar || previous.avatar || '',
          subjectType: 0,
          canEdit: typeof previous.canEdit === 'boolean' ? previous.canEdit : false,
          canDownload: typeof previous.canDownload === 'boolean' ? previous.canDownload : false
        };
      });
      const nonUserItems = this.selectedItems.filter(item => item.type !== 'user');
      this.selectedItems = this.uniqueSelectedItems([...nonUserItems, ...nextUserItems]);
    },
    syncMemberPickerValueFromSelected() {
      const userIds = this.selectedItems
        .filter(item => item.type === 'user' && item.id !== undefined && item.id !== null && item.id !== '')
        .map(item => String(item.id));
      this.memberPickerValue = userIds.join(',');
    },

    /**
     * 加载当前权限数据
     * @param {String} resourceId - 资源ID
     * @param {Number} resourceType - 资源类型 0-文件夹 1-文件
     */
    loadCurrentPermissions(resourceId, resourceType) {
      this.permissionLoading = true;
      this.$HttpService.post("/permission/getPermissionDetail", {
        resourceId: resourceId,
        resourceType: resourceType
      })
        .then(res => {
          // 清空已选择项
          this.selectedItems = [];
          this.form.publicFlag = res.publicFlag

          const hasGranularUserPermission = Array.isArray(res.editUserIdSet) || Array.isArray(res.downloadUserIdSet);
          const hasGranularRolePermission = Array.isArray(res.editRoleIdSet) || Array.isArray(res.downloadRoleIdSet);
          const hasGranularDeptPermission = Array.isArray(res.editDeptIdSet) || Array.isArray(res.downloadDeptIdSet);

          const editUserIdSet = new Set(res.editUserIdSet || []);
          const downloadUserIdSet = new Set(res.downloadUserIdSet || []);
          const editRoleIdSet = new Set(res.editRoleIdSet || []);
          const downloadRoleIdSet = new Set(res.downloadRoleIdSet || []);
          const editDeptIdSet = new Set(res.editDeptIdSet || []);
          const downloadDeptIdSet = new Set(res.downloadDeptIdSet || []);

          // 处理用户权限
          if (res.userIdSet && res.userIdSet.length > 0) {
            res.userIdSet.forEach(userId => {
              const user = this.permissionData.userList.find(u => u.id === userId);
              if (user) {
                this.selectedItems.push({
                  type: 'user',
                  id: user.id,
                  name: user.fullName || user.username,
                  avatar: user.avatar,
                  subjectType: 0,
                  canEdit: hasGranularUserPermission ? editUserIdSet.has(user.id) : true,
                  canDownload: hasGranularUserPermission ? downloadUserIdSet.has(user.id) : true
                });
              }
            });
          }
          this.syncMemberPickerValueFromSelected();

          // 处理角色权限
          if (res.roleIdSet && res.roleIdSet.length > 0) {
            res.roleIdSet.forEach(roleId => {
              const role = this.permissionData.roleList.find(r => r.id === roleId);
              if (role) {
                this.selectedItems.push({
                  type: 'role',
                  id: role.id,
                  name: role.roleName,
                  subjectType: 2,
                  canEdit: hasGranularRolePermission ? editRoleIdSet.has(role.id) : true,
                  canDownload: hasGranularRolePermission ? downloadRoleIdSet.has(role.id) : true
                });
              }
            });
          }

          // 处理部门权限
          if (res.deptIdSet && res.deptIdSet.length > 0) {
            res.deptIdSet.forEach(deptId => {
              // 从部门树中查找部门信息
              const dept = this.findDeptInTree(this.permissionData.deptTreeList, deptId);
              if (dept) {
                this.selectedItems.push({
                  type: 'dept',
                  id: dept.deptId,
                  name: dept.deptName,
                  subjectType: 1,
                  canEdit: hasGranularDeptPermission ? editDeptIdSet.has(dept.deptId) : true,
                  canDownload: hasGranularDeptPermission ? downloadDeptIdSet.has(dept.deptId) : true
                });
              }
            });

            // 切换到部门标签页，确保部门树被渲染
            this.subjectType = 1;

            // 使用 $nextTick 确保部门树渲染完成后再设置选中状态
            // 将 ID 转换为与部门树 node-key 相同的类型
            this.$nextTick(() => {
              if (this.$refs.deptTree) {
                // 确保类型一致，统一转换为数字类型（或根据实际情况转为字符串）
                const checkedKeys = res.deptIdSet.map(id => {
                  // 如果部门树的 deptId 是数字类型，则转为数字
                  return typeof id === 'string' ? Number(id) : id;
                });
                this.$refs.deptTree.setCheckedKeys(checkedKeys);
              }
            });
          }

          this.permissionLoading = false;
        })
        .catch(() => {
          this.$message.error("获取当前权限数据失败");
          this.permissionLoading = false;
        });
    },

    /**
     * 在部门树中查找部门
     * @param {Array} tree - 部门树
     * @param {Number|String} deptId - 部门ID
     */
    findDeptInTree(tree, deptId) {
      if (!tree || tree.length === 0) return null;

      for (let node of tree) {
        // 使用 == 进行比较，允许数字和字符串的比较
        if (node.deptId == deptId) {
          return node;
        }
        if (node.children && node.children.length > 0) {
          const found = this.findDeptInTree(node.children, deptId);
          if (found) return found;
        }
      }
      return null;
    },

    /**
     * 确认提交
     */
    handleConfirm() {
      // 如果是编辑权限模式，不需要验证文件夹名称
      if (this.isEditMode) {
        this.confirmLoading = true;

        // 按勾选项拆分权限：编辑=1，下载=2
        const permissions = this.selectedItems.flatMap(item => {
          const result = [];
          result.push({
            subjectType: item.subjectType,
            subjectId: item.id,
            permissionType: 0
          });
          if (item.canEdit) {
            result.push({
              subjectType: item.subjectType,
              subjectId: item.id,
              permissionType: 1
            });
          }
          if (item.canDownload) {
            result.push({
              subjectType: item.subjectType,
              subjectId: item.id,
              permissionType: 2
            });
          }
          return result;
        });

        if (this.form.publicFlag == 1) {
          this.form.permissions = []
        } else {
          this.form.permissions = permissions
        }
        this.form.resourceId = this.editResourceId
        this.form.resourceType = this.editResourceType
        // 调用更新权限接口
        this.$HttpService.post("/permission/update", this.form)
          .then(() => {
            this.$message.success("权限设置成功");
            this.$emit("refresh");
            if (this.form.resourceType === 0) {
              this.$emit("folder", this.form.resourceId);
            } else {
              this.$emit("ok", this.form.resourceId);
            }
            this.handleClose();
          })
          .catch(() => {
            this.confirmLoading = false;
          });
      } else {
        // 新增文件夹模式
        // this.$refs.form.validate(valid => {
        //   if (valid) {
        //     this.confirmLoading = true;

        //     // 构建请求参数
        //     const params = {
        //       parentId: this.parentId,
        //       folderName: this.form.folderName,
        //       publicFlag: this.form.publicFlag
        //     };

        //     // 如果是私有文件，添加权限信息
        //     if (this.form.publicFlag === 0) {
        //       params.permissions = this.selectedItems.map(item => ({
        //         subjectType: item.subjectType,
        //         subjectId: item.id
        //       }));
        //     }

        //     // 调用接口
        //     this.$HttpService.post("/file-folder/add", params)
        //       .then(() => {
        //         this.$message.success("新增文件夹成功");
        //         this.handleClose();
        //         this.$emit("refresh");
        //       })
        //       .catch(() => {
        //         this.confirmLoading = false;
        //       });
        //   }
        // });
      }
    }
  }
};
</script>

<style scoped lang="scss">
.permission-selector {
  display: flex;
  gap: 16px;
  height: calc(100vh - 250px);
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  overflow: hidden;
}

// 左侧面板
.left-panel {
  max-width: 40%;
  min-width: 40%;

  flex: 1;
  display: flex;
  flex-direction: column;
  border-right: 1px solid #e4e7ed;
  background-color: #fff;
}

.tab-header {
  display: flex;
  border-bottom: 1px solid #e4e7ed;
  background-color: #f5f7fa;
}

.tab-item {
  flex: 1;
  padding: 5px 10px;
  text-align: center;
  cursor: pointer;
  font-size: 14px;
  color: #606266;
  transition: all 0.3s;
  border-bottom: 2px solid transparent;

  &:hover {
    color: #409eff;
    background-color: #ecf5ff;
  }

  &.active {
    color: #409eff;
    background-color: #fff;
    border-bottom-color: #409eff;
    font-weight: 500;
  }
}

.search-box {
  padding: 12px;
  border-bottom: 1px solid #e4e7ed;
  background-color: #fff;
}

.select-list {
  flex: 1;
  overflow-y: auto;
  padding: 8px 0;
}

.list-content {
  height: 100%;
}

.list-item {
  padding: 5px 10px;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #f5f7fa;
  }

  ::v-deep .el-checkbox {
    width: 100%;

    .el-checkbox__label {
      width: 100%;
    }
  }
}

.item-content {
  display: flex;
  align-items: center;
  gap: 12px;
}

.item-avatar {
  flex-shrink: 0;
}

.item-name {
  font-size: 14px;
  color: #303133;
}

// 右侧面板
.right-panel {
  width: 50%;
  display: flex;
  flex-direction: column;
  background-color: #fafafa;
}

.selected-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 10px;
  border-bottom: 1px solid #e4e7ed;
  background-color: #fff;
  font-size: 14px;
  color: #303133;
  font-weight: 500;
}

.selected-list {
  flex: 1;
  overflow-y: auto;
  padding: 8px;
}

.selected-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 5px 10px;
  margin-bottom: 8px;
  background-color: #fff;
  border-radius: 4px;
  border: 1px solid #e4e7ed;
  transition: all 0.2s;

  &:hover {
    border-color: #409eff;
    box-shadow: 0 2px 4px rgba(64, 158, 255, 0.1);

    .remove-btn {
      opacity: 1;
    }
  }
}

.selected-item-left {
  display: flex;
  align-items: center;
  gap: 12px;

}

.selected-avatar {
  flex-shrink: 0;
}

.selected-info {
  // flex: 1;
  display: flex;
  align-content: center;
  text-align: center;
  min-width: 0;
}

.selected-name {
  font-size: 14px;
  color: #303133;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.selected-id {
  font-size: 12px;
  color: #909399;
  margin-left: 8px;
}

.selected-type {
  font-size: 12px;
  color: #909399;
  margin-left: 2px;
}

.remove-btn {
  flex-shrink: 0;
  opacity: 0;
  transition: opacity 0.2s;
  color: #909399;
  padding: 4px;

  &:hover {
    color: #f56c6c;
  }
}

// 部门树样式
::v-deep .el-tree {
  padding: 0 12px;
  background-color: transparent;

  .el-tree-node__content {
    height: 36px;
    border-radius: 4px;

    &:hover {
      background-color: #f5f7fa;
    }
  }
}

// 空状态样式
::v-deep .el-empty {
  padding: 40px 0;
}

// 滚动条样式
.select-list::-webkit-scrollbar,
.selected-list::-webkit-scrollbar {
  width: 6px;
}

.select-list::-webkit-scrollbar-thumb,
.selected-list::-webkit-scrollbar-thumb {
  background-color: #dcdfe6;
  border-radius: 3px;

  &:hover {
    background-color: #c0c4cc;
  }
}

.select-list::-webkit-scrollbar-track,
.selected-list::-webkit-scrollbar-track {
  background-color: transparent;
}

// 标签容器样式
.tag-container {
  padding: 20px;
  min-height: calc(100vh - 157px);
  max-height: calc(100vh - 157px);
  overflow-y: auto;
}

.tag-group {
  margin-bottom: 24px;
  padding: 16px;
  background-color: #f9fafb;
  border-radius: 8px;
  border: 1px solid #e4e7ed;

  &:last-child {
    margin-bottom: 0;
  }
}

.tag-group-title {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 2px solid #409eff;
}

.tag-options {
  ::v-deep .el-checkbox-group {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
  }

  ::v-deep .el-checkbox {
    margin-right: 0;
  }

  .tag-checkbox {
    ::v-deep .el-checkbox__label {
      padding: 8px 16px;
      background-color: #fff;
      border: 1px solid #dcdfe6;
      border-radius: 4px;
      transition: all 0.3s;
      cursor: pointer;
      font-size: 14px;
      color: #606266;

      &:hover {
        border-color: #409eff;
        color: #409eff;
      }
    }

    ::v-deep .el-checkbox__input.is-checked+.el-checkbox__label {
      background-color: #ecf5ff;
      border-color: #409eff;
      color: #409eff;
      font-weight: 500;
    }

    ::v-deep .el-checkbox__input {
      display: none;
    }
  }
}

.dialog-footer {
  padding: 16px 20px;
  text-align: right;
  border-top: 1px solid #e4e7ed;
  background-color: #fff;
}

.folder-permission-member-picker {
  display: block;
  margin-top: 12px;
  width: 100%;
}
</style>
